import denomination from 'support/helpers/denomination'

export default function (id, name, price, quantity) {
  const format = denomination

  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'removeFromCart',
      ecommerce: {
        remove: {
          products: [{
            name: name,
            id: id,
            price: format(price),
            quantity: quantity
          }]
        }
      }
    })
  }
}
